/**
 * @generated SignedSource<<c6fcc8dde2521e18f6c4f345c71758d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMarketContext_viewer$data = {
  readonly isNftAuctionV2Enabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_viewer">;
  readonly " $fragmentType": "useMarketContext_viewer";
};
export type useMarketContext_viewer$key = {
  readonly " $data"?: useMarketContext_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketContext_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMarketContext_viewer",
  "selections": [
    {
      "alias": "isNftAuctionV2Enabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftAuctionV2"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketSettings_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "14912c46f40f81480888196e0ee9fa01";

export default node;
